// extracted by mini-css-extract-plugin
export default {"feedbackForm":"styles_feedbackForm__NKdKf","attach":"styles_attach__Hspbt","assign":"styles_assign__UO+ZO","submit":"styles_submit__RBMa3"};